import React from 'react'
import NewsletterSubscriptionForm from './NewsletterSubscriptionForm'

function NewsletterComponent() {
    return (
        <div className='flex gap-6 py-16 flex-col items-center justify-center w-full bg-gradient-to-r from-violet-600 via-indigo-600 to-purple-700'>
            <div className='flex flex-col gap-3 text-center max-w-2xl mx-auto px-4'>
                <p className='text-xl md:text-2xl font-bold text-white'>Inscreva-se na nossa newsletter!</p>
                <p className='text-base md:text-lg text-white/90'>Você receberá dicas estratégicas para acelerar o seu aprendizado em inglês de maneira eficaz e sem perder tempo.</p>
            </div>
            <div className='w-full max-w-3xl px-4'>
                <NewsletterSubscriptionForm button={"Inscrever-se"} />
            </div>
        </div>
    )
}

export default NewsletterComponent